import { Address } from '@src/main/modules/messages/domain/address/address.interface';

export interface AddressEntity {
  addressId?: string;
  description: string;
  email: string;
}

export function toAddress(entity: AddressEntity): Address {
  return {
    addressId: entity.addressId ?? '',
    description: entity.description,
    email: entity.email,
  };
}

export function fromAddress(model: Address): AddressEntity {
  return {
    ...model,
  };
}
